<script setup>
import InputWithUnit from "../InputWithUnit.vue";

defineProps(['id', 'label', 'min', 'step', 'max', 'unit', 'displayMultiplier'])

const model = defineModel();
</script>

<template>
    <div class="field field--quantity">
        <label :for="id" v-html="label"></label>

        <div class="quantity-field">
            <button @click.prevent="model--" :disabled="model <= 1" :aria-label="`Decrease ${label} by 1`" class="whippet-button style--outlined color--navy icon-only minus">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M24,12 C24,12.4180456 23.661107,12.7569386 23.2430614,12.7569386 L0.756938604,12.7569386 C0.338892956,12.7569386 0,12.4180456 0,12 C0,11.5819544 0.338892956,11.2430614 0.756938604,11.2430614 L23.2430614,11.2430614 C23.661107,11.2430614 24,11.5819544 24,12 Z"/></svg>
            </button>

            <InputWithUnit :id="id" :min="min" :step="step" :max="max" :unit="unit" :display-multiplier="displayMultiplier" v-model="model" />
            
            <button @click.prevent="model++" :disabled="max && model >= max" :aria-label="`Increase ${label} by 1`" class="whippet-button style--outlined color--navy icon-only plus">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12,0 C12.4180456,0 12.7569386,0.338892956 12.7569386,0.756938604 L12.756,11.2430614 L23.2430614,11.2430614 C23.661107,11.2430614 24,11.5819544 24,12 C24,12.4180456 23.661107,12.7569386 23.2430614,12.7569386 L12.756,12.7560614 L12.7569386,23.2430614 C12.7569386,23.661107 12.4180456,24 12,24 C11.5819544,24 11.2430614,23.661107 11.2430614,23.2430614 L11.243,12.7560614 L0.756938604,12.7569386 C0.338892956,12.7569386 0,12.4180456 0,12 C0,11.5819544 0.338892956,11.2430614 0.756938604,11.2430614 L11.243,11.2430614 L11.2430614,0.756938604 C11.2430614,0.338892956 11.5819544,0 12,0 Z"/></svg>
            </button>
        </div>
    </div>
</template>
